import { useState, useEffect } from 'react'

/**
 * Debounces a value by a configurable delay (default 300ms).
 *
 * Usage:
 *   const [input, setInput] = useState('')
 *   const debouncedInput = useDebounce(input, 300)
 *
 *   // debouncedInput updates 300ms after input stops changing
 */
export function useDebounce<T>(value: T, delayMs = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debouncedValue
}
